import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { LocationNameMapperService } from '../../location-name-mapper/location-name-mapper.service';
import { MappingConfig, MappingStrategy, MappingType } from '../interfaces';

@Injectable({
  providedIn: 'root',
})
export class LocationMappingStrategy implements MappingStrategy {
  public readonly strategyType = MappingType.LOCATION;
  public readonly priority = 1;

  private locationService = inject(LocationNameMapperService);

  public isReady(): Observable<boolean> {
    return this.locationService.isReady;
  }

  public resolve(id: unknown): string | undefined {
    return this.locationService.getLocationName(id);
  }

  public validateConfig(config: MappingConfig): boolean {
    return !!(config.idField && config.nameField);
  }
}
